import React from 'react';
import { ArrowLeft } from 'lucide-react';
import MarketingHeader from '../components/MarketingHeader';
import LegalFooter from '../components/LegalFooter';
import PricingCards from '../components/PricingCards';
import useDocumentMeta from '../hooks/useDocumentMeta';

/* Standalone, linkable pricing page. The cards themselves are shared with
   the homepage pricing section (src/components/PricingCards.jsx) so the
   two can never drift apart. */

const PricingPage = () => {
  useDocumentMeta({
    title: 'Pricing — Your first 100 nodes are free | Factory OS',
    description:
      'Factory OS pricing: every organization starts free with 100 nodes — a node is a part, sub-assembly, assembly, or product. Then $250/user/month with up to 2,500 nodes (Enterprise beyond that); solo founders and startups under five engineers pay $50; university teams with a .edu email are free. Enterprise and Founding Partner options available.',
    path: '/pricing',
  });

  return (
    <div className="fos-notebook min-h-screen">
      <MarketingHeader />

      <section className="pt-14 sm:pt-20 pb-12 md:pb-[72px] px-5">
        <div className="max-w-[1080px] mx-auto">
          <a href="/" className="inline-flex items-center gap-2 no-underline mb-8" style={{ fontFamily: 'var(--mono)', fontSize: 'var(--t-sm)', color: 'var(--ink-3)', letterSpacing: '0.4px' }}>
            <ArrowLeft size={14} /> Back to Factory OS
          </a>

          <div className="max-w-[720px] mb-8">
            <div className="nb-eyebrow" style={{ color: 'var(--nb-accent)' }}>pricing</div>
            <h1 className="mt-2" style={{ fontFamily: 'var(--hand)', fontWeight: 700, fontSize: 'var(--t-lg)', lineHeight: 1.05, color: 'var(--ink)', letterSpacing: '-0.5px' }}>
              Engineering infrastructure for serious hardware.
            </h1>
            <p className="mt-3" style={{ fontFamily: 'var(--hand)', fontSize: 'var(--t-md)', color: 'var(--ink-2)' }}>
              Start free — your first 100 nodes are on us. Built for organizations that treat engineering as a competitive advantage.
            </p>
          </div>

          <PricingCards />
        </div>
      </section>

      {/* The free notebook — the physical on-ramp */}
      <section className="py-12 px-5" style={{ borderTop: '1px dashed var(--ink-4)' }}>
        <div className="max-w-[1080px] mx-auto flex flex-wrap items-baseline gap-x-4 gap-y-2">
          <span className="nb-eyebrow" style={{ color: 'var(--nb-accent)' }}>the free notebook</span>
          <span style={{ fontFamily: 'var(--hand)', fontWeight: 700, fontSize: 'var(--t-md)', color: 'var(--ink)' }}>Sketch on paper. Keep it forever.</span>
          <span style={{ fontFamily: 'var(--hand)', fontSize: 'var(--t-md)', color: 'var(--ink-2)', lineHeight: 1.4 }}>
            Every page has a QR code — scan it and your sketch becomes a node.
          </span>
          <a href="/start" className="no-underline" style={{ fontFamily: 'var(--mono)', fontSize: 'var(--t-sm)', color: 'var(--nb-accent)', letterSpacing: '0.4px' }}>
            Get yours →
          </a>
        </div>
      </section>

      <LegalFooter />
    </div>
  );
};

export default PricingPage;
